import { jsx as _jsx } from "react/jsx-runtime";
import { useXR } from './xr.js';
import { forwardRef, useEffect, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import tunnel from 'tunnel-rat';
/**
 * component to render html elements as overlay for handheld AR experiences
 */
export const XRDomOverlay = forwardRef((props, ref) => {
    const domOverlayRoot = useXR((xr) => xr.domOverlayRoot);
    const { In, Out } = useMemo(tunnel, []);
    useEffect(() => {
        const root = createRoot(domOverlayRoot);
        root.render(_jsx(Out, {}));
        return () => root.unmount();
    }, [domOverlayRoot, Out]);
    return (_jsx(In, { children: _jsx("div", { ...props, ref: ref }) }));
});
